import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

import { FORM_SELECT_MENU_PROPS } from '../utils/formSelectMenu'

export default createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'light',
  },
  defaults: {
    VAutocomplete: {
      menuProps: FORM_SELECT_MENU_PROPS,
    },
    VCombobox: {
      menuProps: FORM_SELECT_MENU_PROPS,
    },
    VSelect: {
      menuProps: FORM_SELECT_MENU_PROPS,
    },
  },
})
